import * as Yup from 'yup';

export const initialValues = {
    strategicSummary: [{ value: '' }],
};

export const validationSchema = Yup.object().shape({
    strategicSummary: Yup.array().of(
        Yup.object().shape({
            value: Yup.string().required('Requerido'),
        })
    ),
});
